// gatsby-browser.js
import './src/styles/webfonts.css';
import './src/styles/global.css';
import './src/styles/manual.css';
import './src/styles/plyr.css';

import { isTestMode } from './src/utils/testMode';

const onRouteUpdate = () => {
  // Persist ?test=1 into sessionStorage on every page, so the test-mode
  // flag survives client-side navigation (e.g. video list → video detail).
  // Without this, pages whose phase gate short-circuits (archives) never
  // call isTestMode() and the flag is silently dropped.
  isTestMode();

  // Scroll to the top of the page on route update
  window.scrollTo(0, 0);
};

export { onRouteUpdate };
